<template>
  <a :href="jobUrl" class="jl-card" :class="{ 'jl-card--applied': applied }">
    <JobCompanyLogo
      :company-name="job.company_name || job.job_designation"
      :logo-url="job.company_logo_url"
      root-class="jl-card__logo"
    />
    <div class="jl-card__body">
      <div class="jl-card__head">
        <div class="jl-card__title">{{ job.job_designation }}</div>
        <span v-if="job.prem_stat" class="jl-card__badge jl-card__badge--premium">Premium</span>
      </div>
      <p v-if="job.company_name" class="jl-card__company">
        <v-icon class="jl-card__meta-icon" size="14">{{ $icons.layers }}</v-icon>
        <span class="jl-card__company-text">{{ job.company_name }}</span>
      </p>
      <ul class="jl-card__meta">
        <li v-if="coursesText" class="jl-card__meta-item">
          <v-icon class="jl-card__meta-icon" size="14">{{ $icons.school }}</v-icon>
          <span class="jl-card__meta-text">{{ coursesText }}</span>
        </li>
        <li v-if="locationText" class="jl-card__meta-item">
          <v-icon class="jl-card__meta-icon" size="14">{{ $icons.mapMarker }}</v-icon>
          <span class="jl-card__meta-text">{{ locationText }}</span>
        </li>
        <li v-if="salaryText" class="jl-card__meta-item">
          <v-icon class="jl-card__meta-icon" size="14">{{ $icons.cashMultiple }}</v-icon>
          <span class="jl-card__meta-text">{{ salaryText }}</span>
        </li>
        <li v-if="job.last_date" class="jl-card__meta-item">
          <v-icon class="jl-card__meta-icon" size="14">{{ $icons.calendarRange }}</v-icon>
          <span class="jl-card__meta-text">Apply by {{ job.last_date }}</span>
        </li>
      </ul>
    </div>
    <span
      class="jl-card__cta"
      :class="{ 'jl-card__cta--applied': applied }"
    >{{ applied ? 'Applied' : 'View & apply' }}</span>
  </a>
</template>

<script>
import JobCompanyLogo from '@/components/JobCompanyLogo.vue';

export default {
  name: 'JobCardList',
  components: { JobCompanyLogo },
  props: {
    job: { type: Object, required: true },
    jobBasePath: { type: String, default: '/jobs/' },
    applied: { type: Boolean, default: false },
  },
  computed: {
    jobUrl() {
      return this.jobBasePath + this.job.param;
    },
    locationText() {
      if (!this.job.cities || !this.job.cities.length) return '';
      return this.job.cities.join(', ');
    },
    coursesText() {
      if (!this.job.courses || !this.job.courses.length) return '';
      return this.job.courses.map(c => c.name).join(', ');
    },
    salaryText() {
      if (this.job.salary_flag || !this.job.salary_range_from || this.job.salary_range_from <= 0) {
        return '';
      }
      let text = `₹${this.job.salary_range_from}`;
      if (this.job.salary_range_to) text += ` – ₹${this.job.salary_range_to}`;
      return text + '/month';
    },
  },
};
</script>
